import React from 'react'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import { Card, Row } from 'antd'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import { apiGenerator } from '../../../../util/functions'
import { useParams } from 'react-router-dom'
import Heading from '../../../../component/common/Heading'

const Feedback = () => {
    const { id } = useParams()

    // console.log(id);

    const userFeedBackApi = apiGenerator(CONSTANTS.API.Feedback.getAll, {}, `?userId=${id}`)

    // console.log(userFeedBackApi);
    return (
        <>
            <div>
                <Card>
                    <Heading>FeedBack</Heading>

                    <Row>
                        <CRUDComponent
                            GET={{
                                API: userFeedBackApi,
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `F${data?.id.toString().padStart(7, "0")}`,
                                            feedback: data?.feedback?.question,
                                            rating: data?.rating ? {
                                                ratings: data?.rating
                                            } : '-',

                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.USER_FEEDBACK,
                            }}
                            isSearch={true}

                        />
                    </Row>
                </Card>
            </div>


        </>
    )
}

export default Feedback